import _sfc_main from './volume-container.vue.js';
/* empty css                      */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const VolumeContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d5dbc96c"]]);

export { VolumeContainer as default };
//# sourceMappingURL=volume-container.js.map
